module.exports = __webpack_public_path__ + "static/avatar1-8f0601cced80e372f1029111befb82cc.png";